<template>
  <div>
    <!-- 订单详情标签批量修改条码格式；不与配送单组件共用。 -->
    <el-dialog title="标签批量修改条码格式" :close-on-click-modal="false" :visible.sync="dialogVisible" width="780px" center>
      <div class="content">
        <div class="row">
          <div class="label">原始仓库类型:</div>
          <div class="val">
            <el-radio-group v-model="datas.from_no_type">
              <el-radio label="FBA">亚马逊FBA</el-radio>
              <el-radio label="LETIAN">乐天</el-radio>
              <el-radio label="YAHU">雅虎</el-radio>
              <el-radio label="ZOZO">ZOZO</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="row">
          <div class="label">原始标签编码格式:</div>
          <div class="val">
            <el-radio-group v-model="datas.from_code_type">
              <el-radio label="CODE128">CODE128</el-radio>
              <el-radio label="EN13">EN13</el-radio>
              <el-radio label="EN8">EN8</el-radio>
              <el-radio label="CODE39">CODE39</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="border"></div>
        <div class="row">
          <div class="label">目标仓库类型:</div>
          <div class="val">
            <el-radio-group v-model="datas.to_no_type">
              <el-radio label="FBA">亚马逊FBA</el-radio>
              <el-radio label="LETIAN">乐天</el-radio>
              <el-radio label="YAHU">雅虎</el-radio>
              <el-radio label="ZOZO">ZOZO</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="row">
          <div class="label">目标标签编码格式:</div>
          <div class="val">
            <el-radio-group v-model="datas.to_code_type">
              <el-radio label="CODE128">CODE128</el-radio>
              <el-radio label="EN13">EN13</el-radio>
              <el-radio label="EN8">EN8</el-radio>
              <el-radio label="CODE39">CODE39</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t("message.cancel") }}</el-button>
        <el-button type="primary" @click="save">{{ $t("message.ok") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    saveHandler: { type: Function, default: null },
  },
  data() {
    return {
      datas: {
        from_code_type: '',
        to_code_type: '',
        order_sn: '',
        from_no_type: '',
        to_no_type: '',
        order_detail_tag_id_set: [],
      },
      dialogVisible: false,
    }
  },
  methods: {
    setData(data) {
      this.datas = {
        from_code_type: '',
        to_code_type: '',
        order_sn: data.order_sn,
        from_no_type: '',
        to_no_type: '',
        order_detail_tag_id_set: data.order_detail_tag_id_set,
      }
      this.dialogVisible = true
    },
    // 订单详情只提交 order.tag.batchModifyCodeType，不触碰配送单接口。
    save() {
      if (!this.saveHandler) return
      Promise.resolve(this.saveHandler(JSON.parse(JSON.stringify(this.datas))))
        .then(() => { this.dialogVisible = false })
        .catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-radio__inner { transform: scale(1.5) !important; }
.content {
  margin: 0 15px;
  .row {
    display: flex;
    margin-bottom: 20px;
    .label { line-height: 40px; margin-right: 30px; }
    .val { flex: 3; line-height: 40px; }
  }
  .border { margin: 20px 0; height: 1px; width: 100%; background: #ccc; }
}
</style>
